export const Logo = ({ className = "", size = "default" }) => {
  const heights = {
    small: "h-6",
    default: "h-8",
    large: "h-10",
  };

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      {/* Fast-forward icon */}
      <svg
        viewBox="0 0 36 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${heights[size]} w-auto`}
      >
        {/* Back chevron (darker) */}
        <path
          d="M16 2.5C16 1.12 17.52 0.3 18.68 1.08L34.68 13.58C35.62 14.2 35.62 15.8 34.68 16.42L18.68 28.92C17.52 29.7 16 28.88 16 27.5V2.5Z"
          fill="#3730A3"
        />
        {/* Front chevron (brighter) */}
        <path
          d="M2 2.5C2 1.12 3.52 0.3 4.68 1.08L20.68 13.58C21.62 14.2 21.62 15.8 20.68 16.42L4.68 28.92C3.52 29.7 2 28.88 2 27.5V2.5Z"
          fill="#6366F1"
        />
      </svg>
      {/* Text */}
      <span className={`font-extrabold tracking-tight ${size === 'small' ? 'text-base' : size === 'large' ? 'text-2xl' : 'text-[1.25rem]'}`}>
        <span className="text-indigo-500">indi</span>
        <span className="text-indigo-900">bids</span>
      </span>
    </div>
  );
};
